export default "__VITE_ASSET__5d177788__"